import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import sheepicon from "../../../assests/images/animal.png";
import farmicon from "../../../assests/images/farm.png";
import GMapPolygen from "../../../components/GMapPolygen";
import GmapMultiple from "./GmapMultiple";
import { Column,Pie } from "@ant-design/plots";
 
const Farmer360Form = (props) => {
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [farmerId, setfarmerId] = useState(0);
  const [farmerListData, setFarmerListData] = useState([]);
  const [farmerinformationData, setfarmerinformationData] = useState([]);
  const [plotDataList, setplotDataList] = useState([]);
  const [cropList, setcropList] = useState([]);
  const [farmDetails, setfarmDetails] = useState([]);
  const [farmer, setfarmer] = useState([]);
  const [ngoDetails, setngoDetails] = useState([]);
  const [livestock, setlivestock] = useState([]);
  const [familydDetail, setfamilyDetail] = useState([]);
  const [machineryDetails, setmachineryDetails] = useState([]);
  const [contractDetails, setContractDetails] = useState([]);
  const [regionId, setRegionId] = useState(0);
  const [regionData, setRegionData] = useState([]);


 
  const [cropwiseAreacovered, setCropwiseAreacovered] = useState([]);




  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  const [totalLand, settotalLand] = useState(0);
  const [cropsCount, setcropsCount] = useState(0);
  const [livestockCount, setlivestockCount] = useState(0);
  const [machineryCount, setmachineryCount] = useState(0);
  const [familyCount, setfamilyCount] = useState(0);

  const [coordinate, setcoordinate] = useState([]);
  const [marketCoordinate, setMarketCoordinate] = useState([]);
  const [plotCoordinateList, setPlotCoordinateList] = useState([]);


  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // //console.log("region", data);

        setRegionData(data);
      }
    );
  }, [getRegion]);

  const farmerOnchangedHandler = (Id) => {
    // //console.log(event.target.value);
    
    setfarmerId(Id);
    setfamilyCount(0);
    setlivestockCount(0);
    setmachineryCount(0);
    var farmerlst = farmerListData.filter((item) => item.farmerId == Id);

    //console.log("Selected Farmer", farmerlst[0]);
    var farmerItem = farmerlst && farmerlst[0];
    if (farmerItem)
    { 
      FillFarmersContract(farmerItem&&farmerItem.farmerId);
      settotalLand(farmerlst[0].totalLand + " " + farmerlst[0].totalLandUnit);
      var machineryCt = 0;
      if (farmerItem.machineryDetails && farmerItem.machineryDetails.length > 0) {


        farmerItem.machineryDetails.forEach((item) => {
          machineryCt += parseFloat(item.machineEquipmentCount || 0);

        });

      }
      setmachineryCount(machineryCt);

      var liveStockCt = 0;
      if (farmerItem.liveStockItem && farmerItem.liveStockItem.length > 0) {


        farmerItem.liveStockItem.forEach((item) => {
          liveStockCt += parseFloat(item.count || 0);

        });

      }
      setlivestockCount(liveStockCt);


      setlivestock(farmerItem.liveStockItem && farmerItem.liveStockItem);
      setfamilyDetail(farmerItem.familyDetails && farmerItem.familyDetails);
      setmachineryDetails(
        farmerItem.machineryDetails && farmerItem.machineryDetails
      );
      FarmerDashBoardView(farmerlst[0].farmerId);
      getPlotData(farmerlst[0].farmerId);
      setfarmer(farmerlst[0]);
      var familyDetails = farmerItem.familyDetails;
      setfamilyCount(familyDetails && familyDetails.length);

  }
  };

  const { sendRequest: getFarmerDashBoardView } = useHttp();

  const FarmerDashBoardView = (farmerId) => {
    getFarmerDashBoardView(
      {
        url: `/api/getFarmerDashBoardView/?farmerId=${farmerId}`,
      },
      (data) => {
        if (data) {
          // //console.log("farmerData", data.output);

          setcropsCount(data.output.cropsCount);
          // setlivestockCount(data.output.livestockCount);
          // setmachineryCount(data.output.machineryCount);
          // setfamilyCount(data.output.familyCount)
        }
      }
    );
  };

  const { sendRequest: getEmp } = useHttp();
  const getEmployeeData = (id) => {
    var regionId1;
    // farmerSelectListData=[];
    setFarmerListData([]);
    setfarmerinformationData([]);

    var url = `/api/employeelist/?orgId=${localStorage.getItem("orgId")}`;

    if (id > 0) {
      var url = `/api/employeelist/?orgId=${localStorage.getItem(
        "orgId"
      )}&regionId=${id}`;
    }
    getEmp(
      {
        url: url,
      },
      (data) => {
        var emplist = data.output.filter(
          (item) => item.useCase == "Procurement"
        );

        setEmployeeData(emplist);
        getFarmersData(0);
      }
    );
  };


  const { sendRequest: getFarmersContract } = useHttp();

  const FillFarmersContract = (farmerId) => {


    getFarmersContract(
      {
        url: `/api/contractCropViewList/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerId=${farmerId}`,
      },
      (data) => {
       console.log("data.contractCropViewList", data);
        setContractDetails(data)
      }
    );
  };



  
  const { sendRequest: getFarmers } = useHttp();

  const getFarmersData = (empId) => {
    const pdata = { createdBy: empId };
    // farmerSelectListData=[];
    setFarmerListData([]);
    setfarmerinformationData([]);
    // //console.log("empId", empId);
    getFarmers(
      {
        url: `/api/getfarmerDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${empId}`,
      },
      (data) => {
        console.log("data.farmerDetails", data);
         
        setFarmerListData(data.output);
      }
    );
  };

  const { sendRequest: getPlot } = useHttp();

  const getPlotData = (farmerId) => {
    const pdata = { createdBy: 5 };
    // farmerSelectListData=[];

    // //console.log("farmerId", farmerId);


    var markerList = [];
    var PlotCoordinatetempList = [];


    getPlot(
      {
        url: `/api/getfarmerplotDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerId=${farmerId}`,
      },
      (data) => {
        console.log("data of plot coordinate", data.output);
        var filterplot = data.output;

        // //console.log("filterplot", filterplot);
        setplotDataList(filterplot);

        var filterAllCropplot  =[];
        var polId = 1;


        filterplot.forEach((item) => {
          var coordinates = {};


          console.log("cropsDetails", item.cropsDetails);
          
          var strcrop= JSON.stringify(item.cropsDetails);
          var clist =JSON.parse( JSON.parse(strcrop));
          console.log("clist", clist);

          clist.forEach((citem) => {

            filterAllCropplot = filterAllCropplot.concat({
              cropName: citem.cropName,
              area: item.plotArea,
            });

          }
          )

          if (item && item.plotCoordinates) {
            var plotCorodinate = [];

            if (item.plotCoordinates.includes('"')) {
              plotCorodinate = JSON.parse(item.plotCoordinates);
            } else {
              plotCorodinate = item.plotCoordinates;
            }

            coordinates = {
              lat: plotCorodinate[0].latitude,
              lng: plotCorodinate[0].longitude,
            };

             var colorcode = "Green";
              var croplist = "";

          //   console.log("item plotId",item.plotId)
          //   var cropselectItem =filterCrop.filter(
          //     (eitem) =>( eitem.plotId==item.plotId)
          //   );
            
      

          //   console.log("cropselectItem",cropselectItem)
          //  if (cropselectItem&&cropselectItem.length>0)
          //   {
          //     var  cropItem=cropselectItem[0]; 
             
          //     console.log("map color",cropItem.mapColor)
          //     colorcode=cropItem.mapColor;
          //       // if ((cropItem.procurement || "") != "") {
          //       //   colorcode = "Green";
          //       // } else if ((cropItem.fieldQc || "") != "") {
          //       //   colorcode = "#ffbf00";
          //       // } else if (
          //       //   (cropItem.pruningDate || "") != "" ||
          //       //   (cropItem.sowingDate || "") != ""
          //       // ) {
          //       //   colorcode = "Cyan";
          //       // } else {
          //       //   colorcode = "Red";
          //       // }
                
          //   croplist=cropItem.farmerName+" ("+cropItem.cropName+")"
            
          // }

            markerList = markerList.concat({
              lat: plotCorodinate[0].latitude,
              lng: plotCorodinate[0].longitude,
              tittle: item.farmerName + croplist,
              markeyType: colorcode,
              id:  polId,
            });

            var plotNewCoordinates = [];

            plotCorodinate.map((item) => {
              plotNewCoordinates = plotNewCoordinates.concat({
                lat: item.latitude,
                lng: item.longitude,
              });
            });
            
           console.log("set color",colorcode) 

            PlotCoordinatetempList = PlotCoordinatetempList.concat({
              plotCorodinate: plotNewCoordinates,
              colorCode: colorcode,
              id: "ply" + polId,
            });
          }

          polId = polId + 1;
        });
        setMarketCoordinate([...markerList]);
        setPlotCoordinateList([...PlotCoordinatetempList]);

        if (PlotCoordinatetempList.length > 0) {
          setcoordinate([...PlotCoordinatetempList[0].plotCorodinate]);
        }
        console.log("set filterAllCropplot",filterAllCropplot) 
        loadProcurementDetailcovered(filterAllCropplot)
      }
    );
  };

  useEffect(() => {
    getPlotData();
  }, [getPlot]);





  const loadProcurementDetailcovered = (data) => {


    //console.log("loadProcurementDetailcovered",data)


    if (data && data.length > 0) {
      var tempData = data;

       
      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalarea = 0;
        selectedcroplist.forEach((item) => {
          totalarea += parseFloat(item.area || 0);
        });

        var totalplotAreaUnit = "Kg";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          CropArea: totalarea,
        });

        i++;
      } while (croplist.length > i);

       console.log("cropwiseProcurment 456",newcropData)    ;

      cropwiseAreacovered(newcropData);
    }
  };

  const CropwiseAreaPieConfig = {
    appendPadding: 10,
    data:cropwiseAreacovered,
    angleField: 'CropArea',
    colorField: 'CropName',
    radius: 0.75,
    label: {
      type: 'spider',
      labelHeight: 28,
      content: '{name}\n{percentage}',
    },
    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
    ],
  };


  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <h2 className="mx-3 my-1">
                Farmer Detail
              </h2>
            </div>
            <div className="row"> &nbsp;
            </div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">

                  <label htmlFor={"regionName"} >Region</label>

                  <select
                    id="regionId"
                    className="form-control"
                    ref={(el) => (frmRef.current["regionId"] = el)}
                    value={regionId}
                    onChange={(e) => {
                      setRegionId(e.target.value);
                      getEmployeeData(e.target.value);
                    }}
                  >
                    <option>All Region</option>
                    {regionData &&
                      regionData.map((x) => (
                        <option

                        key={x.regionId}
                        region-id={x.regionId}
                              value={x.regionId}

                          
                        >
                          {x.regionName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>{"Procurement Officer"}</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);

                      getFarmersData(e.target.value);
                    }}
                  >
                    <option>Select Employee</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} user-id={x.userId} 
                        value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label >{"Farmer Name"}</label>
                  <select
                    id="farmerId"
                    className="form-control"
                    ref={(el) => (frmRef.current["farmerId"] = el)}
                    value={farmerId}
                    onChange={(e) => {

                      var Id = 0
                      if(e.target.value!="--Select Farmer--")
                      {
                        Id=e.target.value
                      }

                      farmerOnchangedHandler(Id);
                    }}

                  >
                    <option>--Select Farmer--</option>
                    {farmerListData &&
                      farmerListData.map((x) => (
                        <option
                          key={x.farmerId}
                          farmer-id={x.farmerId}
                          value={x.farmerId}
                        >
                          {x.farmerName + "(" + x.farmerNo + ")"}
                        </option>
                      ))}
                  </select>
                </div>

              </div>




              <div className="col-md-2">
                <div className="form-group">

                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                  onClick={(e) => {
                    farmerOnchangedHandler(farmerId??0);
                  }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h4>Please select the parameters to get the desired result</h4>
          <hr />
        </section>
          <section className="content">
          <div className="container-fluid">

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" >


                    <div className="row">



                      <div className="col-md-3 col-sm-6 col-12">
                        <div className="info-box">
                          <span className="info-box-icon bg-info">
                            <img
                              src={farmicon}
                              height="30"
                              width="30"

                              style={{ opacity: ".8" }}
                            />
                          </span>

                          <div className="info-box-content">
                            <span className="info-box-text">Field</span>
                            <span className="info-box-number">{totalLand}</span>
                          </div>

                        </div>

                      </div>

                      <div className="col-md-3 col-sm-6 col-12">
                        <div className="info-box">
                          <span className="info-box-icon bg-info"><i className="fas fa-seedling"></i></span>

                          <div className="info-box-content">
                            <span className="info-box-text">Crops</span>
                            <span className="info-box-number">{cropsCount}</span>
                          </div>


                        </div>

                      </div>

                      <div className="col-md-3 col-sm-6 col-12">
                        <div className="info-box">
                          <span className="info-box-icon bg-info">
                            <img
                              src={sheepicon}
                              height="30"
                              width="30"

                              style={{ opacity: ".8" }}
                            />
                          </span>

                          <div className="info-box-content">
                            <span className="info-box-text">Livestock</span>
                            <span className="info-box-number">{livestockCount}</span>
                          </div>

                        </div>

                      </div>


                      <div className="col-md-3 col-sm-6 col-12">
                        <div className="info-box">
                          <span className="info-box-icon bg-info"><i className="fas fa-truck-monster"></i></span>

                          <div className="info-box-content">
                            <span className="info-box-text">Machinery</span>
                            <span className="info-box-number">{machineryCount}</span>
                          </div>

                        </div>

                      </div>



                    </div>

                    <div className="row">

                      <div className="col-md-7">


                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-map mr-1"></i>
                              Map
                            </h3>
                            <div className="card-tools">


                            </div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">

                              <div className="chart tab-pane active" id="revenue-chart"
                              >
                                <GmapMultiple
                          coordinate={coordinate}
                          marketCoordinate={marketCoordinate}
                          plotCoordinateList={plotCoordinateList}
                          mapzoom={19}
                        />
                              </div>
                              <div className="chart tab-pane" id="sales-chart"
                              >

                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="col-md-5">

                      <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-chart-pie mr-1"></i>
                              Plot Detail
                            </h3>
                            <div className="card-tools">
                          
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">

                            <table className="table table-bordered text-center" style={{width:"100%"}}>
                        <thead>
                          <tr>
                            
                            <th>Plot Type </th>
                            <th>Area </th>
                           
                          </tr>
                        </thead>
                        <tbody>
                          {plotDataList &&
                            plotDataList.map((x, i) => (
                              <tr key={i}>
                                  
                                <td>{x.plotName}</td>

                                <td>{x.plotArea} &nbsp;{x.plotAreaUnit}</td>

                                 
                              </tr>
                            ))}
                        </tbody>
                        </table>
                            </div>
                          </div>
                        </div>
                              
                      </div>
                    </div>


                   

                    <div className="row">



                       

                      <div className="col-md-4">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-chart-pie mr-1"></i>
                              Family Detail
                            </h3>
                            <div className="card-tools">

                            </div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">

                              <div className="chart tab-pane active" id="revenue-chart">
 
                                {familydDetail &&
                                  familydDetail.map((itm, i) => {
                                    return (
                                      <div key={i}>
                                        <div>  {itm.name}</div>
                                        <div>  {itm.gender}|{itm.age}|{itm.relationship}</div>
                                        <div>   {itm.education}</div>
                                      </div>
                                    );
                                  })}
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-md-4">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-chart-pie mr-1"></i>
                              Machinery
                            </h3>
                            <div className="card-tools">

                            </div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">

                              <div className="chart tab-pane active" id="revenue-chart">
 
                              {machineryDetails &&
                                  machineryDetails.map((itm, i) => {
                                    return (
                                      <div key={i}>
                                        <div>  {itm.machineEquipmentName}-{itm.machineEquipmentCount}</div>

                                      </div>
                                    );
                                  })}
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-md-4">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-chart-pie mr-1"></i>
                              Livestock
                            </h3>
                            <div className="card-tools">

                            </div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">

                              <div className="chart tab-pane active" id="revenue-chart">
 
                              {livestock &&
                                  livestock.map((itm, i) => {
                                    return (
                                      <div key={i}>
                                        <div>  {itm.name}-{itm.count}</div>

                                      </div>
                                    );
                                  })}
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>



                       
                    </div>


<div>

<div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-chart-pie mr-1"></i>
                              Plot Photos
                            </h3>
                            <div className="card-tools">

                            </div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">

                              <div className="chart tab-pane active" id="revenue-chart">
 
                              {plotDataList?.plotPhotosUrls&&JSON.parse(plotDataList?.plotPhotosUrls)?.map(
                                    (url, index) => (
                                      <div className="col-md-4" key={index}>
                                        <img
                                          src={`${process.env.REACT_APP_FILE_URL}${url}`}
                                          alt={`Plot photo ${index + 1}`}
                                          width={200}
                                        />
                                        &nbsp;
                                      </div>
                                    )
                                  )}
                               
                              </div>

                            </div>
                          </div>
                        </div>
</div>

                   

                    <div className="row">

<div className="col-md-12">



<div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-chart-pie mr-1"></i>
                              Contract Detail
                            </h3>
                            <div className="card-tools">
                          
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">

                           
        <table className="table table-bordered text-center" style={{width:"100%"}}>
                        <thead>
                          <tr>
                            
                            <th>Plot Name </th>
                            <th>Area </th>
                            <th>Crop </th>
                            <th>Variety </th>
                            <th>Collection Center </th>
                            <th>Grower Code </th>
                            <th>Deal Date </th>
                            <th>Deal End Date </th>
                            <th>Sowing Date </th>
                            <th>Harvesting Date  </th>
                            <th>Contract Status </th>
 
                          </tr>
                        </thead>
                        <tbody>
                          {contractDetails &&
                            contractDetails.map((x, i) => (
                              <tr key={i}>
                                  
                                <td>{x.plotName}</td>

                                <td>{x.plotArea} &nbsp;{x.plotAreaUnit}</td>
                                <td>{x.cropName}  </td>
                                <td>{x.varietyName}  </td>
                                <td>{x.collectionCenterName}  </td>
                                <td>{x.growerCode}  </td>
                                <td>{x.dealDate}  </td>
                                <td>{x.dealEndDate}  </td>
                                <td>{x.sowingDate}  </td>
                                <td>{x.harvestingDate}  </td>
                                <td>  </td>
                                 
                              </tr>
                            ))}
                        </tbody>
                        </table>
 

                            </div>
                          </div>
                        </div>


     
      </div>
</div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default Farmer360Form;
